import { render, staticRenderFns } from "./clientArticleEditor.pug?vue&type=template&id=7881d034&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./clientArticleEditor.scss?vue&type=style&index=0&id=7881d034&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7881d034",
  null
  
)

export default component.exports